import React from 'react';
import PrimaryLogo from 'shared/img/primary-logo-blue.svg';
import AuthImage from 'shared/img/auth.svg';

interface Props {
  page: 'login' | 'signup';
}

const Layout = ({children, page = 'login'}: React.PropsWithChildren<Props>) => (
  <div className="shared-auth-layout">
    <section className="shared-auth-layout-left">
      <a href="/" className="shared-auth-layout-logo-link">
        <PrimaryLogo height={22} />
      </a>
      {children}
    </section>
    <section className={`shared-auth-layout-right ${page}`}>
      <AuthImage />
    </section>
  </div>
);

export default Layout;
